import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import MakeRequest from '../Components/Helpers/MakeRequest';
import { useOutletContext } from 'react-router-dom';
import QuillExports from '.././Components/Helpers/QuillHelpers';

const About = () => {
  const { l } = useOutletContext();
  const { SafeHtml } = QuillExports();

  const [about, setAbout] = useState({
    content: { sv: "", en: "" },
  });

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await MakeRequest(null, 'content/pageContent?page=about', 'get');
        if (response.data) {
          setAbout(response.data[0]);
        }
      } catch (error) {
        console.error('Error fetching retailers:', error);
      }
    };
    fetchAbout();
  }, []);

  return (
    <>
      <Container className="my-lg-5 my-3">
        <div className="mb-5">
          <h1 className="mb-3 fw-bold">
            {l("Vision & idé", "Vision & idea")}
          </h1>
          <p className="mb-3 mb-md-4 text-break">
            {l(about.content?.titleSwe, about.content?.titleEng)}
          </p>
        </div>

        <Row className="g-4 align-items-start">
          {/* Text first on all sizes */}
          <Col xs={12} md={6}>
            <div className="text-break">
              <SafeHtml html={l(about.content?.sv, about.content?.en)} />
            </div>
          </Col>

          {/* Image stacks below text on small/medium, sits side-by-side ≥ md */}
          <Col xs={12} md={6}>
            {about.image && (
              <img
                src={about.image}
                alt="Example"
                loading="lazy"
                className="img-fluid w-100 d-block mb-2"
                style={{ objectFit: 'contain' }}
              />
            )}
          </Col>
        </Row>
      </Container>

    </>
  );
};

export default About;